import * as React from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheck } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import AddActivity from "./AddActivity";
import VisitCollapse from './VisitCollapse';
import CantVisitsModal from "./CantVisitsModal";
import UpdateVisitsModal from "./UpdateVisitsModal";
import ListVisits from './ListVisits';
import ModalMUI from '@material-ui/core/Modal';
import { formatNumber } from '../../../Utils/Money';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';

const Budget = ({ location }) => {
    const feasibility = location.state;
    const history = useHistory();

    const [budget, setBudget] = React.useState(null);
    const [costo, setCosto] = React.useState(0);
    const [valor_venta, setValorVenta] = React.useState(0);
    const [presupuesto, setPresupuesto] = React.useState(0);
    const [cantVisit, setCantVisits] = React.useState(0);

    //Tab
    const [addActivities, setAddActivities] = React.useState(false);
    const [addCant, setAddCant] = React.useState(false);
    const [updateVisitModalView, setUpdateVisitModalView] = React.useState(false);

    const [visits, setVisits] = React.useState([]);

    const [visitSelected, setVisitSelected] = React.useState(null);

    const [isLoading, setIsLoading] = React.useState(false);

    const [actividades, setActividades] = React.useState([]);

    const configureOverview = (e) => {
        e.preventDefault();
    }

    const addActivitiesModal = (e) => {
        setAddActivities(true);
    }

    const closeActivitiesModal = (e) => {
        setAddActivities(false);
    }

    const addCantVisitsModal = (e) => {
        setAddCant(true);
    }

    const closeVisitsModal = (e) => {
        setAddCant(false);
    }

    const updateVisitModal = (e) => {
        setVisitSelected(e);
        setUpdateVisitModalView(true);
    }

    const closeUpdateVisitModal = (e) => {
        setVisitSelected(null);
        setUpdateVisitModalView(false);
    }

    const consultarPresupuestoPorFactibilidad = async (id_factibilidad) => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factibilidad/${id_factibilidad}/consultarpresupuesto`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(data => {
            setBudget(data.presupuesto);
            setCosto(data.presupuesto.costo);
            setValorVenta(data.presupuesto.valor_venta);
            setPresupuesto(data.presupuesto.presupuesto);
            setCantVisits(data.presupuesto.cant_visitas != null ? data.presupuesto.cant_visitas : 0);
            listVisits(data.presupuesto.id_factibilidad);
        }).catch(err => {

        });
    }

    const listVisits = async (id_factibilidad) => {
        fetch(`${process.env.REACT_APP_PUBLIC_URL}visitas/consultar`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ id_factibilidad: id_factibilidad })
        }).then(response => response.json()).then(data => {
            setVisits(data.contenido);
            console.log(data);
        }).catch(err => {
            console.log(err);
            setVisits([]);
        });
    }

    const regresar = () => {
        let _url = "/clinical-studio/dashboard";
        history.push({
            pathname: process.env.PUBLIC_URL + _url,
            state: feasibility
        });
    }

    const updateTotals = (costo, valor_venta, presupuesto) => {
        setCosto(parseFloat(costo));
        setValorVenta(parseFloat(valor_venta));
        setPresupuesto(parseFloat(presupuesto));
    }

    const loadActivities = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}servicio/listar`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(data => {
            let opcionesActividades = [];
            for (let i = 0; i < data.length; i++) {
                const opcion = { activity: data[i].nombre };
                opcionesActividades.push(opcion);
            }
            setActividades(opcionesActividades);

        }).catch(err => {
            console.log(err);
            setActividades([]);
        });
    }

    React.useEffect(() => {
        setIsLoading(true);
        consultarPresupuestoPorFactibilidad(feasibility.id_factibilidad);
        setIsLoading(false);
        loadActivities();
    }, []);


    const AllVisits = () => {
        let _row = [];
        try {
            setIsLoading(true);
            visits.map((item, i) => _row.push(
                {
                    visita: <div>
                        <VisitCollapse
                            visit={item}
                            number_visit={item.num_visita}
                            cost={parseFloat(item.costo)}
                            sponsor={parseFloat(item.presupuesto)}
                            diff={parseFloat(item.valor_venta)}
                            editVisitAction={updateVisitModal}
                            title={item.nombre != null ? item.nombre : ""}
                            activities={item.actividades.actividades}
                            feasibility={location.state}
                            className="with-shadow"
                            actividades={actividades}
                            />
                    </div>
                }


            ));
        }
        catch (e) {
            setIsLoading(false);
        }

        setIsLoading(false);

        return (

            <ListVisits reactTableData={_row} />

        );
    }

    const AddActivityBudget = () => {
        return (
            <AddActivity
                opened={addActivities}
                budget={budget}
                addActivitiesModal={addActivitiesModal}
                closeActivitiesModal={closeActivitiesModal}
                consultarPresupuestoPorFactibilidad={consultarPresupuestoPorFactibilidad}
                cantVisitBudget={cantVisit}
                visits={visits}
                actividades={actividades}
            />
        );
    }

    const ModalCantVisits = () => {
        return (
            <CantVisitsModal
                budget={budget}
                CloseCantVisitsModal={closeVisitsModal}
                opened={addCant}
                listVisits={listVisits}
                originalCantVisit={cantVisit}
                setOriginalCantVisit={setCantVisits}
                updateTotals={updateTotals}
            />

        );
    }

    return (<Container>
        <Row>
            <Col md={12}>
                <h3 className="page-title center-title">Administrar Presupuesto</h3>
                <h3 className="page-title center-title subhead">{feasibility.nombre_tercero} ({feasibility.acronimo})</h3>

                <Col md={2}>
                    <div className='top_info_buttons_hc'>
                        <div>
                            <Tooltip
                                title="Regresar al Dashboard"
                            >
                                <IconButton
                                    aria-label="upload picture"
                                    component="span"
                                    className='tooltip-top'
                                    onClick={() => {
                                        regresar();
                                    }}
                                >
                                    <ArrowBackIcon style={{ color: '#153365' }} />
                                </IconButton>
                            </Tooltip>
                            <span style={{ marginLeft: '0.25em' }}>Regresar al Dashboard</span>
                        </div>
                    </div>
                </Col>


            </Col>
        </Row>

        <Card className="card--flex">
            <CardBody className="width_static">
                <h3 className="page-title center-title"></h3>

                <Row>
                    <Col md={4}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <h4><b>Costo</b></h4>
                            <h3 style={{ color: '#0084CF' }}><b>$ {costo != null && costo != undefined ? formatNumber(costo) : ""}</b></h3>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <h4><b>Valor de Venta</b></h4>
                            <h3 style={{ color: '#0084CF' }}><b>$ {valor_venta != null && valor_venta != undefined ? formatNumber(valor_venta) : ""}</b></h3>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <h4><b>Presupuesto</b></h4>
                            <h3 style={{ color: '#0084CF' }}><b>$ {presupuesto != null && presupuesto != undefined ? formatNumber(presupuesto) : ""}</b></h3>
                        </div>
                    </Col>
                </Row>
                <br />

                <div className="text-center">
                    <Button className="btn btn-primary btn-sm" type="button" color="primary"
                        onClick={() => addCantVisitsModal()}>
                        Cantidad Visitas
                    </Button>

                    <Button className="btn btn-primary btn-sm" type="button" color="primary"
                        onClick={addActivitiesModal}>
                        Agregar Actividad
                    </Button>

                    {/*
                    <Button disabled={true} className="btn btn-primary btn-sm" type="button" color="primary"
                        onClick={configureOverview}>
                        Configurar Overhead
                    </Button>
                    */}
                    <AddActivityBudget />
                    <ModalCantVisits />
                </div>
            </CardBody>
        </Card>

        <Card className="card--flex">
            <CardBody className="width_static">
                <Container>
                    <h3 className="page-title center-title">Lista de Visitas</h3>
                    <AllVisits />

                    <UpdateVisitsModal
                        visit={visitSelected}
                        opened={updateVisitModalView}
                        CloseUpdateVisitModal={closeUpdateVisitModal}
                        maxNum={visits != null ? visits.length : 0}
                        feasibility={location.state}
                    />
                </Container>

            </CardBody>
        </Card>

        <ModalMUI
            open={isLoading}
            onClose={() => {
                setIsLoading(false);
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
        >
            <div className="paperAppointment-flex" style={{ borderColor: 'white', boxShadow: 'white', height: '300x', width: '30%', margin: 10 }}>
                <div className="text-center">
                    <br /><br /><br />
                    <div class="load__icon-wrap">
                        <svg class="load__icon">
                            <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                        </svg>
                    </div>
                    <br /><br /><br />
                </div>
            </div>
        </ModalMUI>
    </Container >);
}

export default reduxForm({
    form: 'form_budget_show', // a unique identifier for this form
})(Budget);